// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-loading-mask .el-loading-spinner .path{stroke:#333}.el-loading-spinner .el-loading-text,.el-loading-spinner i{font-size:18px;color:#333}body{margin:0}", ""]);
// Exports
module.exports = exports;
